import { Link } from 'react-router-dom';
import { usePlaces } from '@/hooks/usePlaces';
import { PlaceCard } from '@/components/PlaceCard';

export function MedicalPage() {
  const { places } = usePlaces();
  const medical = places.filter((p) => p.category === 'medical');

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Medical</h1>
        <p className="page-subtitle">Pharmacy in town, hospital in Portimão</p>
      </div>
      {medical.map((p) => (
        <PlaceCard key={p.id} place={p} />
      ))}
      <Link to="/emergency" className="list-row">
        Emergency 112
      </Link>
    </div>
  );
}
